import { Helmet } from "react-helmet-async";

export const Seo = ({
  title,
  description,
  keywords = [],
  canonical,
  image,
  type = "website",
  jsonLd,
}) => {
  const url = canonical || (typeof window !== "undefined" ? window.location.href : "https://artibirinsaat.com");
  const ogImage =
    image ||
    "https://images.unsplash.com/photo-1586073054612-fdd6537fc6d4?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85";

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords.length > 0 && <meta name="keywords" content={keywords.join(", ")} />}
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content="tr_TR" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      <html lang="tr" />
      {jsonLd &&
        (Array.isArray(jsonLd) ? jsonLd : [jsonLd]).map((entry, i) => (
          <script key={i} type="application/ld+json">
            {JSON.stringify(entry)}
          </script>
        ))}
    </Helmet>
  );
};
